<template>
  <div class="main-content">
    <!-- Section: inner-header -->

    <div class="pt-100">
      <div class="row">
        <div class="col-md-12 t-a-center">
          <h1 class="title text-dark">INVITA UN'AMICO</h1>
        </div>
      </div>

      <section>
        <div class="container pt-40 pb-40">
          <div class="row">
            <div class="col-md-12 t-a-center">
              <div v-if="!invitationCode">
                <h3 class="title text-dark">
                  Puoi generare un codice personale da inviare ai tuoi amici,
                  <span class="text-theme-colored"
                    >tu e il tuo amico riceverete uno sconto del {{invitationDiscountPercentage}}%</span
                  >
                </h3>

                <a
                  v-on:click="GenerareInvitationCode()"
                  style="margin: 1rem"
                  class="btn btn-dark btn-theme-colored btn-m"
                  >Clicca qui per generare il codice</a
                >
              </div>

              <div v-if="invitationCode">
                <h3 class="title text-dark">
                  Condividi il codice con i tuoi amici,
                  <span class="text-theme-colored"
                    >tu e il tuo amico riceverete uno sconto del {{invitationDiscountPercentage}}%</span
                  >
                </h3>

                <h1 class="title text-theme-colored">{{ invitationCode }}</h1>

                <div v-if="webShareApiSupported">
                  <a
                    v-on:click="shareViaWebShare()"
                    style="margin: 1rem"
                    class="btn btn-dark btn-theme-colored btn-m"
                    >CONDIVIDI</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<style scoped>
.t-a-center {
  text-align: center;
}
#about .title.line-bottom {
  padding-bottom: 0;
  margin-bottom: 10px;
}
#about .title.line-bottom::after {
  height: 2px;
  width: 100%;
}

.mh-auto {
  max-height: initial !important;
}
</style>

<script>
import axios from "axios";

export default {
  name: "InviteFriend",
  data() {
    return {
      baseUrl: process.env.VUE_APP_API_URL,
      invitationCode: null,
      invitationDiscountPercentage: 15,
      searchFilter: null,
      videoCollection: [],
    };
  },
  methods: {
    shareViaWebShare() {
       if (navigator.share) { 
         navigator.share({
        title: "Codice sconto",
        text:
          "Utilizza questo codice: " +
          this.invitationCode +
          " per usufruire del " +  this.invitationDiscountPercentage + "% di sconto",
        url: "https://www.sarahfitnessmovementflow.com/",
        });
      }
    },
    GenerareInvitationCode() {
      axios
        .post(process.env.VUE_APP_API_URL + "/user/generateinvitationcode", {})
        .then((response) => {
          if (response.data) {
            axios
              .get(process.env.VUE_APP_API_URL + "/user/getinvitationcode")
              .then((res2) => {
                if (res2.data) {
                  this.invitationCode = res2.data.Code;
                }
              });
          }
        });
    },
    compare(a, b) {
      if (a.Title < b.Title) return -1;
      if (a.Title > b.Title) return 1;
      return 0;
    },
  },
  computed: {
    webShareApiSupported() {
      return navigator.share;
    },
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_URL + "/user/getinvitationcode")
      .then((response) => {
        if (response.data) {
          this.invitationCode = response.data.Code;
        }
      });

      axios
      .get(process.env.VUE_APP_API_URL + "/user/getparameter")
      .then((response) => {
        if (response.data) {
          this.invitationDiscountPercentage = response.data.InvitationDiscountPercentage;
        }
      });
  },
};
</script>